import React from 'react'
import ReactDOM from 'react-dom'
import { ROOT_ID } from '~/config'

class Modal extends React.Component {
  constructor(props) {
    super(props);
    if(typeof document !== 'undefined') {
      let root = document.getElementById(ROOT_ID);
      if(!root) {
        root = document.createElement("div");
        root.id = ROOT_ID
        document.body.insertBefore(root, document.body.firstChild);
      }
      this.modalRoot = root;
      this.el = document.createElement('div');
    }
  }

  componentDidMount() {
    if(typeof document !== 'undefined') {
      this.modalRoot.appendChild(this.el);
    }
  }

  componentWillUnmount() {
    if(typeof document !== 'undefined') {
      this.modalRoot.removeChild(this.el);
    }
  }

  render() {
    if(typeof document !== 'undefined') {
      return ReactDOM.createPortal(
        this.props.children,
        this.el
      );
    }

    return null;
  }
}

export default Modal
